export default "__VITE_ASSET__BsccMWd7__"